import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { FaCheckSquare } from 'react-icons/fa'
import { ReactComponent as TriangleWarningIcon } from '../../../assets/svg/TriangleWarningIcon.svg'
import { ReactComponent as Info } from '../../../assets/svg/InfoIcon.svg'
import { ReactComponent as FlagIconSmall } from '../../../assets/svg/FlagIconSmall.svg'
import { ReactComponent as QuestionIconNew } from '../../../assets/svg/QuestionIconNew.svg'
import { ReactComponent as PollIconNew } from '../../../assets/svg/PollIconNew.svg'
import { format } from 'date-fns'
import { fileSystemUrl } from '../../../constants/Connections'
import Loading from '../../Loading'
import BigImageModal from '../BigImageModal'
import ArchiveItem from './ArchiveItem'

const FeedbackDayBody = ({ feedback, archiveContent, loadingContent, creatingAlert, onCreateAlert }) => {
    const { t } = useTranslation()
    const [selectedImage, setSelectedImage] = useState('')
    const [imageModalOpen, setImageModalOpen] = useState(false)

    const openBigImage = (url) => {
        setSelectedImage(url)
        setImageModalOpen(true)
    }

    const closeImageModal = () => {
        setImageModalOpen(false)
        setSelectedImage('')
    }

    return (
        <>
            <div className="feedback-modal-messege-body">
                {feedback.message && (
                    <>
                        <p className="first-letter:uppercase">{t('comment')}</p>
                        <span>{feedback.message}</span>
                        <div className="feedback-spacer" style={{ width: '100%' }}></div>
                    </>
                )}
                <div className="feedback-seenby-row w-full">
                    <p>{t('seenBy')}: </p>
                    <div className="student-feedback-seen-list flex-1">
                        {feedback.seenBy?.map((item, index) => (
                            <div key={index} className="student-feedback-seen-list-item">
                                <p style={{ marginLeft: 5 }}>
                                    {item.first_name} {item.last_name}
                                </p>
                                {feedback.takenActionBy?.includes(item.id) && <FaCheckSquare style={{ margin: 0, marginLeft: 2 }} />}
                                {index < feedback.seenBy?.length - 1 && <p>,</p>}
                            </div>
                        ))}
                    </div>
                    {!feedback.alert_id && !!feedback.message && (
                        <button
                            className="bg-[#F8F8FB] flex flex-row items-center gap-1 rounded-full border-[#5E639B80] h-[40px] px-[15px] border font-semibold text-[14px] text-[#5E639B] transition-all hover:border-[#5E639B]"
                            onClick={onCreateAlert}
                            disabled={creatingAlert}
                            id="mark-as-risk-button"
                        >
                            {creatingAlert ? <Loading secondaryColor="white" /> : <FlagIconSmall />}
                            <p>{t('Mark comment as risk')}</p>
                        </button>
                    )}
                </div>
                {!!feedback.message && (
                    <>
                        {feedback.alert_id ? (
                            <div className="border border-[#FC4C59] w-full p-[12px] rounded-[8px] mt-[8px] flex flex-row bg-[#F8F8FB] gap-[8px]">
                                <div>
                                    <TriangleWarningIcon width={20} height={20} />
                                </div>
                                <div>
                                    {feedback.ai_flagged ? (
                                        <p className="!text-[#5E639B] !text-[14px] !font-bold">{t('This entry was flagged by AI for', { category: feedback?.alert_category })}</p>
                                    ) : (
                                        <p className="!text-[#5E639B] !text-[14px] !font-bold">
                                            {t('This entry was flagged by', {
                                                name: feedback?.alert_created_by?.first_name + ' ' + feedback?.alert_created_by?.last_name,
                                            })}
                                        </p>
                                    )}
                                    <Link to={`/alerts?id=${feedback.alert_id}`}>
                                        <div
                                            className="text-[#5E639B] border border-[#5E639B] rounded-full px-[24px] mt-[8px] self-baseline font-semibold text-[13px] leading-[13px] py-[7.5px] text-center"
                                            style={{ placeSelf: 'baseline' }}
                                        >
                                            {t('See alert')}
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        ) : (
                            <div className="border border-[#5E639B80] w-full p-[12px] rounded-[8px] mt-[8px] flex flex-row bg-[#F8F8FB] gap-[8px]">
                                <div>
                                    <Info width={20} height={20} />
                                </div>
                                <div>
                                    <p className="!text-[#5E639B] !text-[14px] !font-bold">{t('If needed, you can flag this comment')}</p>
                                    <p>{t('This comment has not been marked as a risk, you can change that by clicking the button')}</p>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>

            {feedback.assignments?.map((assignment, index) => (
                <div key={index} className="feedback-modal-assignment-body mt-2">
                    <div className="w-full flex flex-row items-center justify-between">
                        <p className="feedback-modal-assignment-body-text">{t('assignedBy')}: </p>
                        <span className="feedback-modal-assignment-body-span">
                            {assignment.assignedBy.first_name} {assignment.assignedBy.last_name}
                        </span>
                    </div>
                    <div className="feedback-spacer" style={{ width: '100%', marginBottom: 0 }}></div>
                    <div className="w-full mt-[10px]">
                        <div className="w-full flex flex-row items-center justify-between">
                            <p className="feedback-modal-assignment-body-text text-deepPurple">{t('assignedTo')}</p>
                            <span className="feedback-modal-assignment-body-span text-deepPurple">
                                {assignment.assignedTo?.first_name} {assignment.assignedTo?.last_name}
                            </span>
                        </div>
                        <div className="teacher-assignment-box">
                            <p className="teacher-assignment-comment">{assignment.actionMessage}</p>
                        </div>
                    </div>
                </div>
            ))}

            {!loadingContent && archiveContent.length === 0 && (
                <div className="feedback-empty-archive-content">
                    <p>{t('thereAreNoAnswersForThatDay')}</p>
                </div>
            )}
            {!loadingContent && archiveContent.length !== 0 && (
                <div className="flex flex-col mt-5">
                    <p className="text-[16px] font-bold text-deepPurple">{t('tasks')}:</p>
                    {archiveContent?.map((archive, index) => {
                        const type = archive.content?.type
                        if (type !== 'question' && type !== 'poll') return null
                        const url = `${fileSystemUrl}/${archive?.content?.files?.storage_name}`
                        const imgUrl = archive.content?.files ? url : false
                        return (
                            <ArchiveItem
                                key={index}
                                archive={archive}
                                url={url}
                                imgUrl={imgUrl}
                                openBigImage={openBigImage}
                                icon={type === 'question' ? <QuestionIconNew /> : <PollIconNew />}
                                label={type === 'question' ? t('open_question') : t('open_poll')}
                                answerClassName={
                                    type === 'question'
                                        ? 'mb-[6px] rounded-[10px] flex items-center min-h-[40px] py-[10px] px-[20px] bg-lightBG'
                                        : 'mb-[6px] rounded-[10px] flex items-center h-[40px] pl-[20px] bg-deepPurple'
                                }
                                answerTextClassName={type === 'question' ? 'text-[16px] font-medium text-darkenPurple' : 'text-[16px] font-medium text-highlightColor'}
                                time={format(new Date(archive.created_date), 'HH:mm')}
                            />
                        )
                    })}
                </div>
            )}

            <BigImageModal modalIsOpen={imageModalOpen} closeModal={closeImageModal} selectedImage={selectedImage} />
        </>
    )
}

export default FeedbackDayBody
